module.exports = __webpack_public_path__ + "assets/img/banner.21632cf6.png";